import { deepCombineObjects } from "@me8eon/record_utils";
import common from "./common/common.json";
import deAboutUs from "./locales/de/about-us.json";
import deRoadMap from "./locales/de/roadmap.json";
import deRoomBooking from "./locales/de/room-booking.json";
import deTranslation from "./locales/de/translation.json";
import deProductDashboard from "./locales/de/product-dashboard.json";

import enAboutUs from "./locales/en/about-us.json";
import enRoadMap from "./locales/en/roadmap.json";
import enRoomBooking from "./locales/en/room-booking.json";
import enTranslation from "./locales/en/translation.json";
import enProductDashboard from "./locales/en/product-dashboard.json";

import svAboutUs from "./locales/sv/about-us.json";
import svRoadMap from "./locales/sv/roadmap.json";
import svRoomBooking from "./locales/sv/room-booking.json";
import svTranslation from "./locales/sv/translation.json";
import svProductDashboard from "./locales/sv/product-dashboard.json";

import roAboutUs from "./locales/ro/about-us.json";
import roRoadMap from "./locales/ro/roadmap.json";
import roRoomBooking from "./locales/ro/room-booking.json";
import roTranslation from "./locales/ro/translation.json";
import roProductDashboard from "./locales/ro/product-dashboard.json";

import czAboutUs from "./locales/cz/about-us.json";
import czRoadMap from "./locales/cz/roadmap.json";
import czRoomBooking from "./locales/cz/room-booking.json";
import czTranslation from "./locales/cz/translation.json";
import czProductDashboard from "./locales/cz/product-dashboard.json";

import plAboutUs from "./locales/pl/about-us.json";
import plRoadMap from "./locales/pl/roadmap.json";
import plRoomBooking from "./locales/pl/room-booking.json";
import plTranslation from "./locales/pl/translation.json";
import plProductDashboard from "./locales/pl/product-dashboard.json";

import huAboutUs from "./locales/hu/about-us.json";
import huRoadMap from "./locales/hu/roadmap.json";
import huRoomBooking from "./locales/hu/room-booking.json";
import huTranslation from "./locales/hu/translation.json";
import huProductDashboard from "./locales/hu/product-dashboard.json";

import nlAboutUs from "./locales/nl/about-us.json";
import nlRoadMap from "./locales/nl/roadmap.json";
import nlRoomBooking from "./locales/nl/room-booking.json";
import nlTranslation from "./locales/nl/translation.json";
import nlProductDashboard from "./locales/nl/product-dashboard.json";

import itAboutUs from "./locales/it/about-us.json";
import itRoadMap from "./locales/it/roadmap.json";
import itRoomBooking from "./locales/it/room-booking.json";
import itTranslation from "./locales/it/translation.json";
import itProductDashboard from "./locales/it/product-dashboard.json";

import devMode from "./devMode/devmode.json";

export const allDe = deepCombineObjects(devMode, common, deAboutUs, deRoadMap, deRoomBooking, deTranslation, deProductDashboard);
export const allEn = deepCombineObjects(devMode, common, enAboutUs, enRoadMap, enRoomBooking, enTranslation, enProductDashboard);
export const allSv = deepCombineObjects(devMode, common, svAboutUs, svRoadMap, svRoomBooking, svTranslation, svProductDashboard);
export const allRo = deepCombineObjects(devMode, common, roAboutUs, roRoadMap, roRoomBooking, roTranslation, roProductDashboard);
export const allCz = deepCombineObjects(devMode, common, czAboutUs, czRoadMap, czRoomBooking, czTranslation, czProductDashboard);
export const allPl = deepCombineObjects(devMode, common, plAboutUs, plRoadMap, plRoomBooking, plTranslation, plProductDashboard);
export const allHu = deepCombineObjects(devMode, common, huAboutUs, huRoadMap, huRoomBooking, huTranslation, huProductDashboard);
export const allNl = deepCombineObjects(devMode, common, nlAboutUs, nlRoadMap, nlRoomBooking, nlTranslation, nlProductDashboard);
export const allIt = deepCombineObjects(devMode, common, itAboutUs, itRoadMap, itRoomBooking, itTranslation, itProductDashboard);

export const allTranslations = {
    de: allDe,
    en: allEn,
    sv: allSv,
    ro: allRo,
    cz: allCz,
    cs: allCz,
    pl: allPl,
    hu: allHu,
    nl: allNl,
    it: allIt,
};

export const legacyTranslations = {
    en: {
        translation: enTranslation,
        "about-us": enAboutUs,
        "room-booking": enRoomBooking,
        "roadmap": enRoadMap,
        "product-dashboard": enProductDashboard
    },
    de: {
        translation: deTranslation,
        "about-us": deAboutUs,
        "room-booking": deRoomBooking,
        "roadmap": deRoadMap,
        "product-dashboard": deProductDashboard
    },
    sv: {
        translation: svTranslation,
        "about-us": svAboutUs,
        "room-booking": svRoomBooking,
        "roadmap": svRoadMap,
        "product-dashboard": svProductDashboard
    },
    ro: {
        translation: roTranslation,
        "about-us": roAboutUs,
        "room-booking": roRoomBooking,
        "roadmap": roRoadMap,
        "product-dashboard": roProductDashboard
    },
    cz: {
        "about-us": czAboutUs,
        "room-booking": czRoomBooking,
        "translation": czTranslation,
        "roadmap": czRoadMap,
        "product-dashboard": czProductDashboard
    },
    cs: {
        "about-us": czAboutUs,
        "room-booking": czRoomBooking,
        "translation": czTranslation,
        "roadmap": czRoadMap,
        "product-dashboard": czProductDashboard
    },
    pl: {
        "about-us": plAboutUs,
        "room-booking": plRoomBooking,
        "translation": plTranslation,
        "roadmap": plRoadMap,
        "product-dashboard": plProductDashboard
    },
    hu: {
        "about-us": huAboutUs,
        "room-booking": huRoomBooking,
        "translation": huTranslation,
        "roadmap": huRoadMap,
        "product-dashboard": huProductDashboard
    },
    nl: {
        "about-us": nlAboutUs,
        "room-booking": nlRoomBooking,
        "translation": nlTranslation,
        "roadmap": nlRoadMap,
        "product-dashboard": nlProductDashboard
    },
    it: {
        "about-us": itAboutUs,
        "room-booking": itRoomBooking,
        "translation": itTranslation,
        "roadmap": itRoadMap,
        "product-dashboard": itProductDashboard
    },
};
